import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RequiredIndicator from '../../../RequiredIndicator';
import { Headline6 } from '../../../../../../../components/UI/MDC/Typography/Typography';

const SubGroupOrSiteAccessYesNo = ({ handleChange, value }) => {
	const options = ['Yes', 'No'];

	return (
		<>
			<Headline6>
				<RequiredIndicator />
				Does the user require subgroup and/or site access?
			</Headline6>
			<FormControl variant='filled' fullWidth>
				<RadioGroup
					aria-labelledby={'radio-group--SubGroupSiteYES_No'}
					onChange={handleChange}
					value={value}
				>
					{options.map(o =>
						typeof o === 'object' ? (
							<FormControlLabel
								key={o}
								value={o}
								control={<Radio />}
								label={o}
							/>
						) : (
							<FormControlLabel
								key={o}
								value={o}
								control={<Radio />}
								label={o}
							/>
						)
					)}
				</RadioGroup>
			</FormControl>
		</>
	);
};

export default SubGroupOrSiteAccessYesNo;
